import React from "react";

const RemixModalComplete = ({ redirectUrl }) => {
  return (
    <div className="remix-modal-complete flex flex-1 flex-col items-center justify-center px-6 py-4 min-h-[400px] w-full">
      <div className="flex flex-col items-center gap-4 w-full text-center">
        <div
          className="w-16 h-16 rounded-full bg-blue-600 flex items-center justify-center"
          style={{ flexShrink: 0 }}
        >
          <svg
            className="w-8 h-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="3"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h3 className="text-[20px] font-semibold text-slate-800 dark:text-slate-200 m-0">
          All done!
        </h3>
        <p className="text-xl text-slate-500 mt-1">
          You will be redirected automatically. If it doesn't happen,{" "}
          <a href={redirectUrl} className="text-[#003FFF] underline">
            click here
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default RemixModalComplete;
